import HistoryDayGroup from '../HistoryDayGroup/HistoryDayGroup'
import HistoryContentSkeleton from './HistoryContentSkeleton/HistoryContentSkeleton'
import HistoryEmptyState from './HistoryEmptyState/HistoryEmptyState'
import * as Styles from './styles'

const HistoryContent = ({ error, loading, dayGroups }) => {
  if (loading) {
    return <HistoryContentSkeleton />
  }

  if (error || !dayGroups.length) {
    return <HistoryEmptyState error={error} />
  }

  return (
    <Styles.DayGroupsList>
      {dayGroups.map(group => (
        <HistoryDayGroup key={group.label} label={group.label} events={group.events} />
      ))}
    </Styles.DayGroupsList>
  )
}

export default HistoryContent
